import CryptoJS from "crypto-js";
import { ISMENUCOLLAPSED, STORESXUSER } from "src/constants/localStorage";
import { IFilteredStore } from "src/models/Stores/Store.models";

export const getStoresXUser = (): IFilteredStore[] => {
  const encryptedAuth = localStorage.getItem(STORESXUSER);
  if (!encryptedAuth) return [];

  const bytes = CryptoJS.AES.decrypt(
    encryptedAuth,
    process.env.REACT_APP_CRYPTO_SALT || ""
  );

  try {
    var result = JSON.parse(bytes.toString(CryptoJS.enc.Utf8))
    if(result.length > 0)
      return result.map((r: any) => {
        return {storeId: r}
      });
    else 
      return [] as IFilteredStore[];
  } catch {
    return [] as IFilteredStore[];
  }
};

export const setStoresXUser = (auth: number[]): void => {
  const encryptedAuth = CryptoJS.AES.encrypt(
    JSON.stringify(auth),
    process.env.REACT_APP_CRYPTO_SALT || ""
  ).toString();
  localStorage.setItem(STORESXUSER, encryptedAuth);
};

export const removeStoreXUser = (): void => {
  localStorage.removeItem(STORESXUSER);
  localStorage.removeItem(ISMENUCOLLAPSED);
};

export const getIsMenuCollapsed = (): boolean => {
  const item = localStorage.getItem(ISMENUCOLLAPSED);
  if (!item) return false;
  return item === "true";
};

export const setIsMenuCollapsed = (collapseStatus: boolean): void => {
  localStorage.setItem(ISMENUCOLLAPSED, collapseStatus.toString());

  // Crear y despachar el evento personalizado
  const event = new CustomEvent('menuCollapseChange', {
    detail: { collapseStatus },
  });
  window.dispatchEvent(event);
};